export default __webpack_public_path__ + "static/media/strava-marked.59e33da7.png";